export const countActiveFilters = <T extends object>(filters: T) =>
  Object.keys(filters).reduce((acc, key) => {
    const value = filters[key as keyof typeof filters]
    if (Array.isArray(value)) return acc + value.length
    if (value) return acc + 1
    return acc
  }, 0)

export default null
